// ======================================================================
// FILE:
// src/modules/finance/components/FinanceActionButtons.jsx
//
// MODULE:
// Finance & Accounts Management System (FBAMS)
//
// COMPONENT:
// Finance Action Buttons
//
// PURPOSE:
// Displays workflow action buttons based on document status.
//
// FEATURES:
// - Responsive
// - Bootstrap only
// - Workflow aware
// - Permission ready
// - Reusable across Finance transactions
//
// AUTHOR:
// DizyPro ERP
// ======================================================================

import React from "react";

// ======================================================================
// COMPONENT
// ======================================================================

export default function FinanceActionButtons({

    row,

    permissions = {},

    onView,

    onEdit,

    onDelete,

    onSubmit,

    onApprove,

    onReject,

    onPost,

}) {

    const status =
        row?.status;

    const approvalStatus =
        row?.approval_status;

    const canView =
        permissions.view ?? true;

    const canEdit =
        permissions.edit ?? true;

    const canDelete =
        permissions.delete ?? true;

    const canSubmit =
        permissions.submit ?? true;

    const canApprove =
        permissions.approve ?? true;

    const canReject =
        permissions.reject ?? true;

    const canPost =
        permissions.post ?? true;

    return (

        <div
            className="
                d-flex
                flex-wrap
                gap-1
                justify-content-center
            "
        >

            {/* ======================================================
                VIEW
            ====================================================== */}

            {
                canView && (

                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        title="View"
                        onClick={() => onView?.(row)}
                    >

                        <i className="fas fa-eye" />

                    </button>

                )
            }

            {/* ======================================================
                DRAFT
            ====================================================== */}

            {
                status === "DRAFT" && (

                    <>

                        {
                            canEdit && (

                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary"
                                    title="Edit"
                                    onClick={() => onEdit?.(row)}
                                >

                                    <i className="fas fa-edit" />

                                </button>

                            )
                        }

                        {
                            canDelete && (

                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    title="Delete"
                                    onClick={() => onDelete?.(row)}
                                >

                                    <i className="fas fa-trash" />

                                </button>

                            )
                        }

                        {
                            approvalStatus === "PENDING"
                            &&
                            canSubmit && (

                                <button
                                    type="button"
                                    className="btn btn-sm btn-primary"
                                    title="Submit"
                                    onClick={() => onSubmit?.(row)}
                                >

                                    <i className="fas fa-paper-plane me-1" />

                                    Submit

                                </button>

                            )
                        }

                    </>

                )
            }

            {/* ======================================================
                SUBMITTED
            ====================================================== */}

            {
                approvalStatus === "SUBMITTED"
                &&
                canApprove
                &&
                (
                    <button
                        type="button"
                        className="btn btn-sm btn-success"
                        title="Approve"
                        onClick={() => onApprove?.(row)}
                    >

                        <i className="fas fa-check me-1" />

                        Approve

                    </button>
                )
            }

            {
                approvalStatus === "SUBMITTED"
                &&
                canReject
                &&
                (
                    <button
                        type="button"
                        className="btn btn-sm btn-danger"
                        title="Reject"
                        onClick={() => onReject?.(row)}
                    >

                        <i className="fas fa-times me-1" />

                        Reject

                    </button>
                )
            }

            {/* ======================================================
                APPROVED
            ====================================================== */}

            {
                //status === "APPROVED"
                status === "DRAFT"
                &&
                approvalStatus === "APPROVED"
                &&
                canPost
                &&
                (
                    <button
                        type="button"
                        className="btn btn-sm btn-warning"
                        title="Post"
                        onClick={() => onPost?.(row)}
                    >

                        <i className="fas fa-check-double me-1" />

                        Post

                    </button>
                )
            }

        </div>

    );

}